<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的提问  </p>
        </div>
        <div class="content">
            <div class="title">
                <h1>我的提问 <span> / My questions</span></h1>
            </div>
            <ul>
                <li>
                    <div class="box">
                        <p>{{data.question}}</p>
                        <div class="riqi">
                            {{data.createDate | dateTime('yyyy-MM-dd')}}
                        </div>
                    </div>
                </li>
            </ul>
			<div v-for="item in data.ranMsgs" :key="item.id">
				<template v-if="item.userId!=$store.getters.userInfo.id">
					<h2>官方回答：</h2>
					<p class="text" >
					    {{item.content}}
					</p>
				</template>
				<template v-else>
					<h2>我的提问：</h2>
					<p class="text" >
					    {{item.content}}
					</p>
				</template>
				
			</div>
        </div>
		<el-input
			v-if="length&&data.auth==0"
			class="tiwen"
		    type="textarea"
		    :rows="5"
		    placeholder="继续追问"
		    style="width: 375px;"
		    v-model="text">
		</el-input>
		<div class="buttons" v-if="length&&data.auth==0">
		    <el-button :loading="submitLoading" @click="submittttt" >提交</el-button>
		</div>
    </div>
</template>

<script>
import { questionDetail,rankMessageList,rankMessageAdd,questionUdate } from '@/api/center'
import pagination from '@/components/pagination'	
export default {
    name: 'myQuestions',
    components: {
		pagination
    },
    data(){
        return {
            listQuery: {
				page: 1,
				limit: 20,
            },
			data:{},
            total:100,
			content:[],
			text:'',
			submitLoading:false,
			length:null
        }
    },
    mounted(){
		questionDetail({id:this.$route.query.id}).then(res => {
			console.log(res)
			this.data = res
			this.length = res.ranMsgs.length
		})
		rankMessageList({id:this.$route.query.id,userId:this.$store.getters.userInfo.id}).then(res => {
			this.content=res
		})
    },
    methods:{
		submittttt(){
			if(this.text){
				questionUdate({id:this.data.id,status:0}).then(res=>{
					
				})
				this.submitLoading=true
				if(this.data.ranMsgs[this.length]){
					rankMessageAdd({userId:this.$store.getters.userInfo.id,questionId:this.data.id,content:this.text,parentId:this.data.ranMsgs[this.length-1].id}).then(res => {
						this.submitLoading=false
					}).catch(res=>{
						this.submitLoading=false
					})
				}else{
					rankMessageAdd({userId:this.$store.getters.userInfo.id,questionId:this.data.id,content:this.text,parentId:0}).then(res => {
						this.submitLoading=false
					}).catch(res=>{
						this.submitLoading=false
					})
				}
			}else{
				this.$message({
				    message: '请输入提问内容',
				    type: 'warning'
				});
			}
		}
    }
}
</script>

<style scoped>
.tiwen{margin: 30px 0;}
.title{
    display: flex;
    justify-content: space-between;
    
}
.title h1{
    padding-top: 10px;
}
.title h1:after{
    top: 10px;
}
ul{
    margin-bottom: 35px;
}
ul li{
    width: 100%;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #e6e6e6;
    padding: 20px;
    align-items: center;
    box-sizing: border-box;
}
li .box{
    width: 100%;
}
ul{
    width: 100%;
    box-sizing: border-box;
}
ul li span{
    color: #b92f20;
    margin-right: 15px;
}
ul li .box p{
    font-size: 16px;
    font-weight: 600;
    width: 100%;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
}
.riqi{
    color: #666;
}
.text{
    padding: 0 20px;
}
h2{font-weight: 600;line-height: 50px;font-size: 15px;padding-left: 20px;}
</style>
